const App = {
    Init: function () {
        this.LazyLoadImage();
        this.LoadSlider();
        this.LoadRating();
        this.LoadProductList();
        this.LoadProductDetail();
        this.LoadCommonScript();
        this.LoadFAQsPage();
        this.LoadDocumentPage();
        this.LoadAboutPage();
    },
    LoadCommonScript: function () {
        ///Tabs
        $(".tab").on("click", ".tab-link", function (e) {
            e.preventDefault();
            let currentActive = $(this).parents(".tab").find(".tab-link.active");
            currentActive.removeClass("active");
            currentActive.parent().removeClass("active");
            $(this).parents(".tab").find(".tab-content.active").removeClass("active");
            $(this).addClass("active");
            $(this).parent().addClass("active");
            let tab = $(this).data("tab");
            $(this).parents(".tab").find(".tab-content[data-tab='" + tab + "']").addClass("active");
            return false;
        });
        //Toggler
        $(".btn-toggler").on("click", function () {
            let elementId = $(this).data("src");
            $(this).toggleClass("active");
            $("#" + elementId).toggleClass("active");
            if ($(this).hasClass("backdrop-toggler"))
                $(".overlay").toggleClass("active");
            $(".overlay").attr("data-element", elementId);
        });
        //Overlay
        $(".overlay").on("click", function () {
            $(this).toggleClass("active");
            $(".backdrop-toggler.active").toggleClass("active");
            let elementId = $(this).attr("data-element");
            if (elementId != undefined)
                $("#" + elementId).toggleClass("active");
        });
        //Nice select
        $("select.nice").niceSelect();

        $(".content-more").each(function () {
            let currentHeight = $(this).height();
            let max = 500;
            console.log($(this).attr("data-max"));
            if ($(this).attr("data-max") != undefined)
                max = parseInt($(this).attr("data-max"));
            if (currentHeight > max) {
                $(this).addClass("content-max-height");
                $(this).css("height", max + "px");
                $(this).after('<a href="#" class="btn-more" onClick="ViewMore(this);return false;">Xem thêm</a>');
            }
        });

        $("#back-to-top").click(function () {
            return $("body,html").animate({
                scrollTop: 0
            }, 800), !1
        });

        $("body").on("change", ".ajax-product-filter", function () {
            const pageUrl = $(this).val();
            ProcessAjax(pageUrl);
        });
        $("body").on("click",".btn-copy",function (e) {
            e.preventDefault();
            let codeElement = $(this).attr("data-control");
            copyToClipboard(document.getElementById(codeElement).innerHTML);
            let el = $(this);
            $(el).html("Copied");
            setTimeout(function () {
                $(el).html("<i class='mr-2 fa fa-copy'></i>Copy");
            }, 3000);
            return false;
        });
        $("body").on("click",".btn-save",function (e) {
            e.preventDefault();
            let codeElement = $(this).attr("data-control");
            var file = new File([document.getElementById(codeElement).innerHTML], "code.txt", {
                type: "text/plain;charset=utf-8"
            });
            saveAs(file);
            return false;
        });
        AOS.init();
    },
    LazyLoadImage: function () {

    },
    LoadSlider: function () {

        new Swiper(".categories-swiper", {
            pagination: {
                el: ".categories-swiper .swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                }
            },
        });

        new Swiper(".blog-swiper", {
            pagination: {
                el: ".blog-swiper .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".blog-swiper .swiper-button-next",
                prevEl: ".blog-swiper .swiper-button-prev",
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        });

        new Swiper(".customer-swiper", {
            navigation: {
                nextEl: ".customer-swiper .swiper-button-next",
                prevEl: ".customer-swiper .swiper-button-prev",
            },
            autoplay: {
                delay: 3000,
            },
            speed: 1000,
            loop: true,
            slidesPerView: 4,
            spaceBetween: 10,
            breakpoints: {
                640: {
                    slidesPerView: 5,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 8,
                    spaceBetween: 10,
                }
            },
        });

        new Swiper(".home-swiper", {
            pagination: {
                el: ".home-swiper .swiper-pagination",
                clickable: true,
            },
        });

        new Swiper('.banner-swiper', {
            pagination: {
                el: '.banner-swiper .swiper-pagination',
                clickable: true
            },
            loop: true,
            autoplay: {
                delay: 4000,
            },
            speed: 900,
            preloadImages: false
        });

        new Swiper('.product-slider', {
            pagination: {
                el: '.product-slider .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: ".product-slider .swiper-button-next",
                prevEl: ".product-slider .swiper-button-prev",
            },
            autoplay: {
                delay: 3000,
            },
            speed: 1200,
            preloadImages: false
        });

        new Swiper('.featured-swiper', {
            pagination: {
                el: '.featured-swiper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: ".featured-swiper .swiper-button-next",
                prevEl: ".featured-swiper .swiper-button-prev",
            },
            breakpoints: {
                577: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                },
                769: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                },
                1025: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                }
            },
            autoplay: {
                delay: 3000,
            },
            speed: 1200,
            preloadImages: false
        });

    },
    LoadRating: function () {
        $(".rating-view").rate({
            max_value: 5,
            step_size: 0.5,
            readonly: true
        });
        $(".rating").rate({
            max_value: 5,
            step_size: 1,
            readonly: false,
        });
        $(".rating").on("change", function (ev, data) {
            if ($("input[name='Rating']").length > 0)
                $("input[name='Rating']").val(data.to);
        });
    },
    LoadProductList: function () {
        $(document).on("click", ".product-filter-title", function () {
            $(this).parent().siblings().find(".product-filter-body").slideUp();
            $(this)
                .parent()
                .siblings()
                .find(".product-filter-title")
                .removeClass("active");
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
                $(this).next().slideDown();
            } else {
                $(this).removeClass("active");
                $(this).next().slideUp();
            }
        });

        $(".filter-close").on("click", function () {
            $(".product-filter-wrap").slideUp();
            $("body").removeClass("overflow-hidden");
        });

        $(".filter-view-more").on("click", function (e) {
            e.preventDefault();
            let $parent = $(this).parents(".product-filter-group");
            $parent.find("ul li:nth-child(n + 11)").slideToggle();
            $(this).find("em").toggleClass("ri-arrow-down-s-fill ri-arrow-up-s-fill");
            $(this).find("strong").toggleText("Xem thêm", "Rút Gọn");
        });
    },
    LoadProductDetail: function () {
        if ($(window).width() > 1024) {
            var productDetailThumbnail = new Swiper(".product-detail-thumbnail", {
                preloadImages: false,
                lazy: true,
                slidesPerView: 3,
                spaceBetween: 5,
                observer: true,
                observeParents: true
            });
        }

        new Swiper(".product-detail-images", {
            navigation: {
                nextEl: ".product-detail-images .swiper-button-next",
                prevEl: ".product-detail-images .swiper-button-prev",
            },
            thumbs: {
                swiper: productDetailThumbnail
            },
            pagination: {
                el: ".product-detail-images .swiper-slide-count",
                type: "fraction"
            }
        });

        new Swiper(".product-related-swiper", {
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".product-related-swiper .swiper-button-next",
                prevEl: ".product-related-swiper .swiper-button-prev",
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                }
            },
        });

    },
    LoadFAQsPage: function () {
        $(".faqs-list").on("click", ".faq-btn", function () {
            const faq = $(this).parents('.faq');
            faq.find(".faq-content").slideToggle(500);
            faq.toggleClass("active");
        });
    },
    LoadDocumentPage: function () {
        $(".sidenav").on("click", ".submenu-title a", function () {
            const nav = $(this).parent().parent();
            nav.find(".submenu-content").slideToggle(500);
            $(this).toggleClass("active");
        });

        new Swiper('.section-document .swiper', {
            pagination: {
                el: '.section-document .swiper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: ".section-document .swiper .swiper-button-next",
                prevEl: ".section-document .swiper .swiper-button-prev",
            },
            speed: 700,
            preloadImages: false
        });

        $(".sidenav-mobile-toggle").on("click", function () {
            $(".sidenav-wrapper").slideToggle();
            $(".sidenav-wrapper").toggleClass('open');
            if ($(this).find("i").hasClass('fa-indent'))
                $(this).find("i").attr("class", "fa fa-times");
            else
                $(this).find("i").attr("class", "fa fa-indent");
            $("body").toggleClass("uk-overflow-hidden");
        });

        SidebarSearch.Init();

    },
    LoadAboutPage: function () {

        new Swiper('.about-page .swiper', {
            pagination: {
                el: '.about-page .swiper .swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: ".about-page .swiper .swiper-button-next",
                prevEl: ".about-page .swiper .swiper-button-prev",
            },
            autoplay: {
                delay: 3000,
            },
            speed: 700,
            preloadImages: false
        });
    }
}

function copyToClipboard(text) {
    if (window.clipboardData && window.clipboardData.setData) {
        // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
        return window.clipboardData.setData("Text", text);

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        var textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy"); // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return prompt("Copy to clipboard: Ctrl+C, Enter", text);
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

function ProcessAjax(pageurl) {
    //to get the ajax content and display in div with id 'content'
    $.ajax({
        url: pageurl,
        data: {
            isajax: true
        },
        success: function (data) {
            $('.ajaxresponse').html($(data).find('.ajaxresponse').html());
            $('.productpager').remove();
            $(data).find('.productpager').insertAfter($('.ajaxresponse'));
        }
    });

    //to change the browser URL to 'pageurl'
    if (pageurl != window.location) {
        window.history.pushState({
            path: pageurl
        }, '', pageurl);
    }
}

function ViewMore($button) {
    let section = $($button).parent().find(".content-max-height")
    section.removeClass("content-max-height");
    section.css("height", "auto");
    $($button).remove();
}

function OpenWindow(query, w, h, scroll) {
    var l = (screen.width - w) / 2;
    var t = (screen.height - h) / 2;

    winprops = 'resizable=0, height=' + h + ',width=' + w + ',top=' + t + ',left=' + l + 'w';
    if (scroll) winprops += ',scrollbars=1';
    var f = window.open(query, "_blank", winprops);
}

function setLocation(url) {
    window.location.href = url;
}

function htmlEncode(value) {
    return $('<div/>').text(value).html();
}

function htmlDecode(value) {
    return $('<div/>').html(value).text();
}

// CSRF (XSRF) security
function addAntiForgeryToken(data) {
    //if the object is undefined, create a new one.
    if (!data) {
        data = {};
    }
    //add token
    var tokenInput = $('input[name=__RequestVerificationToken]');
    if (tokenInput.length) {
        data.__RequestVerificationToken = tokenInput.val();
    }
    return data;
};

var AjaxCommon = {
    loadWaiting: false,
    //init
    init: function () {
        this.loadWaiting = false;
    },
    //setLoadWaiting
    setLoadWaiting: function (display) {
        this.loadWaiting = display;
    },
    getActiveCode: function ($input) {
        if (this.loadWaiting != false) {
            return;
        }
        this.setLoadWaiting(true);
        let urladd = "/Custom/GetActiveCode";
        let data = {
            'code': $("textarea[name='txtcode']").val()
        };
        addAntiForgeryToken(data);
        $.ajax({
            cache: false,
            url: urladd,
            data: data,
            type: 'post',
            success: function (response) {
                if (response) {
                    $(".result").html(response);
                }
            },
            complete: this.resetLoadWaiting
        });
        return false;
    },
    checkSerial: function () {
        if (this.loadWaiting != false) {
            return;
        }
        this.setLoadWaiting(true);
        let urladd = "/Custom/CheckSerial";
        let data = {
            'serial': $("input[name='txtSeri']").val()
        };
        addAntiForgeryToken(data);
        $.ajax({
            cache: false,
            url: urladd,
            data: data,
            type: 'post',
            success: function (response) {
                if (response) {
                    Fancybox.show(
                        [{
                            src: response,
                            type: "html",
                        }],
                    );
                }
            },
            complete: this.resetLoadWaiting
        });
        return false;
    },
    checkSerialInPage: function ($input, $result) {
        if (this.loadWaiting != false) {
            return;
        }
        this.setLoadWaiting(true);
        let urladd = "/Custom/CheckSerial";
        let data = {
            'serial': $($input).val()
        };
        addAntiForgeryToken(data);
        $.ajax({
            cache: false,
            url: urladd,
            data: data,
            type: 'post',
            success: function (response) {
                if (response) {
                    $($result).html("<div class='alert alert-info'>" + response + "</div>");
                }
            },
            complete: this.resetLoadWaiting
        });
        return false;
    },
    downloadFile: function ($button) {
        if (this.loadWaiting != false) {
            return;
        }
        this.setLoadWaiting(true);
        let divView = $($button).parents("tr").find(".view-count");
        let viewCount = parseInt($(divView).text()) + 1;
        $(divView).text(viewCount);
        let urladd = "/News/UpdateMostView";
        let data = {
            'itemId': $($button).data("id")
        };
        addAntiForgeryToken(data);
        $.ajax({
            cache: false,
            url: urladd,
            data: data,
            type: 'post',
            success: function (response) {
                if (response.viewed)
                    $(divView).text(response.viewed);
            },
            complete: this.resetLoadWaiting
        });
        return false;
    },
    resetLoadWaiting: function () {
        AjaxCommon.setLoadWaiting(false);
    },
};

var SidebarSearch = {
    sidebarSearchSelector: '.sidebar-search',
    sidebarListSelector: '.sidebar-list',
    sidebarResultSelector: '.sidebar-result',
    searchItems: [],
    maxResults: 5,
    Init: function () {
        this.searchItems = [];
        this.Common();
    },
    Common: function () {
        $(this.sidebarListSelector + " li a").each(function (i, result) {
            const itemObject = {};
            const navLink = $(this);
            const link = navLink.attr('href');
            const name = navLink.text();
            itemObject.name = SidebarSearch.TrimText(name);
            itemObject.link = link;
            SidebarSearch.searchItems.push(itemObject);
        });
        $(this.sidebarSearchSelector + " input[type='text']").keyup(function (n) {
            SidebarSearch.CallSuggest($(this).val());
        });
    },
    CallSuggest: function ($searchValue) {
        if ($searchValue.length == 0) {
            $(this.sidebarResultSelector).html('');
            return;
        }
        const searchResults = this.searchItems.filter(function (item) {
            return item.name.toLowerCase().includes($searchValue);
        });
        const endResults = searchResults.slice(0, this.maxResults);

        if (endResults.length == 0) {
            $(this.sidebarResultSelector).html('');
            return;
        }
        let htmlOptions = '';
        $(endResults).each(function () {
            htmlOptions += '<a href="' + this.link + '">' + this.name + '</a>';
        });
        $(this.sidebarResultSelector).html(htmlOptions);
    },
    TrimText: function ($text) {
        return $.trim($text.replace(/(\r\n|\n|\r)/gm, ' '));
    }
}

App.Init();